// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const mewtwo: PokeData = {
  "id": 150,
  "name": "mewtwo",
  "height": 20,
  "weight": 1220,
  "base_experience": 306,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "disable",
    "mist",
    "psybeam",
    "confusion",
    "psychic",
    "agility",
    "teleport",
    "recover",
    "confuse-ray",
    "barrier",
    "swift",
    "amnesia",
    "psywave",
    "safeguard",
    "psych-up",
    "ancient-power",
    "future-sight",
    "calm-mind",
    "miracle-eye",
    "me-first",
    "power-swap",
    "guard-swap",
    "aura-sphere",
    "psycho-cut",
    "psystrike",
    "laser-focus",
    "life-dew"
  ],
  "moves": [
    "psychic",
    "confuse-ray",
    "psywave",
    "ancient-power",
    "future-sight",
    "calm-mind",
    "life-dew",
    "kinesis",
    "healing-wish",
    "psychic-fangs",
    "psy-ball",
    "psychic-terrain",
    "psy-pulse"
  ],
  "evolution_chain": {
    "id": 77,
    "item": null,
    "species": [
      {
        "name": "mewtwo",
        "order": 182,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 103,
    "speed": 136,
    "ability_power": 161
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
